import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import Hero from "../designSystem/Hero";
import HeroBackground from "../../assets/images/home_header.jpg";
import SEO from "../designSystem/SEO";
import LightOutlinedButton from "../designSystem/buttons/LightOutlinedButton";
import LineLinkButton from "../designSystem/buttons/LineLinkButton";
import { ReactComponent as MortgageAdvice } from "../../assets/icons/mortgage_advice.svg";
import { ReactComponent as PensionAdvice } from "../../assets/icons/pension_advice.svg";
import { ReactComponent as InvestmentAdvice } from "../../assets/icons/investment_advice.svg";
import { ReactComponent as PersonalApproach } from "../../assets/icons/personal_approach.svg";
import MortgageImage1 from "../../assets/images/mortgage_image_001.jpg";
import MortgageImage2 from "../../assets/images/mortgage_image_002.jpg";
import MortgageImage3 from "../../assets/images/mortgage_image_003.jpg";
import MortgageImage4 from "../../assets/images/mortgage_image_004.jpg";
import MortgageImage5 from "../../assets/images/mortgage_image_005.jpg";
import FAQ from "../designSystem/FAQ";
import { scrollToContact } from "../utils/navigation";
import { useNavigate } from "react-router-dom";

const calculators = [
  {
    title: "Mortgage Repayment",
    image: MortgageImage3,
    description:
      "Estimate your monthly repayments based on the mortgage, interest rate a mortgage term.",
    link: "/calculators/mortgage-repayment",
  },
  {
    title: "Mortgage Affordability",
    image: MortgageImage4,
    description:
      "Get an initial indication of how much you may potentially be able to borrow.",
    link: "/calculators/mortgage-affordability",
  },
  {
    title: "Mortgage Overpayment",
    image: MortgageImage5,
    description:
      "See how making additional mortgage payments could affect your mortgage balance.",
    link: "/calculators/mortgage-overpayment",
  },
];

const MortgagePage = () => {
  const navigate = useNavigate();

  return (
    <div>
      <SEO
        title="Mortgage Advice"
        description="Understand your mortgage options for buying a first home, moving home or remortgaging with personal mortgage advice from Monk Financial Planning."
        path="/mortgages"
      />
      <Hero
        //         title={`Financial Clarity
        // Direction & Confidence`}
        //         subtitle="Wealth Management Solutions"
        showOverlay={true}
        // backgroundImage={HeroBackground}
        titleAlign="center"
        subtitleAlign="center"
        pageTitle="Mortgages"
        title="Mortgage Advice"
        subtitle="Buying a home or reviewing your mortgage is a major financial decision. We can help you understand your options and guide you through the process. Our aim is to give you clarity, so you can move forward with confidence."
        showButton={true}
        textAlign="center"
      ></Hero>

      <div className="background-container bg-primary-1 ">
        <div className="content-container row align-stretch gap-xxxxl py-xxl px-xxxl row-reverse row-ratio-47-63">
          <div className="column gap-l">
            <LineLinkButton children="Mortgages" />
            <h4 className="text-gray-3 uppercase">
              Making Your Next Move With Confidence
            </h4>
            <div className="column gap-m">
              <div className="content text-gray-3">
                Whether you’re buying your first home, moving house or looking
                to remortgage, we can help you understand what may be available
                based on your circumstances. We’ll take the time to understand
                your needs, explain your options and guide you through the
                mortgage process, helping you make informed decisions with
                confidence.
              </div>
              <div className="content text-gray-3">
                From understanding how much you may be able to borrow to
                considering different mortgage products and repayment options,
                we can help you understand the key factors involved. Our aim is
                to make the process as clear and straightforward as possible, so
                you know what to expect at each stage.
              </div>
            </div>
          </div>
          <img src={MortgageImage1} alt="Couple reviewing their mortgage options" className="image-cover" />
        </div>
      </div>
      <div className="background-container bg-gray-3 ">
        <div className="content-container column align-center gap-l py-xxl px-xxxl">
          <LineLinkButton children="Mortgages" />
          <h4 className="uppercase text-primary-1">How we can help</h4>
          <FAQ
            items={[
              {
                question: "First-Time Buyers",
                answer:
                  "We can help you understand how much you may be able to borrow, the deposit required and what your monthly repayments could look like. We’ll explain the key considerations and help you understand your potential mortgage options before you start your property search.",
              },
              {
                question: "Moving Home",
                answer:
                  "We can review your current mortgage and help you understand how your existing arrangement may fit with your plans to move home. We can also discuss your options for a new mortgage and help you understand what may be suitable for your circumstances.",
              },
              {
                question: "Remortgaging",
                answer:
                  "When your current mortgage deal is coming to an end, it can be worth reviewing what is available. We can help you understand your options, whether that means staying with your current lender or considering a new mortgage that may better suit your circumstances.",
              },
              {
                question: "Ongoing Support",
                answer:
                  "Whether you know exactly what you need or simply have a question, we’re here to help. We can provide guidance throughout the mortgage process and answer your questions, helping you feel informed and supported from your initial enquiry through to completion.",
              },
            ]}
          />
        </div>
      </div>
      <div className="background-container bg-primary-1 ">
        <div className="content-container row align-stretch gap-xxxxl py-xxl px-xxxl row-ratio-47-63">
          <img src={MortgageImage2} alt="Homebuyer discussing a mortgage application" className="image-cover" />{" "}
          <div className="column gap-l">
            <LineLinkButton children="Mortgage Fees" />
            <h4 className="text-gray-3 uppercase">
              Looking Beyond the Interest Rate
            </h4>
            <div className="column gap-m">
              <div className="content text-gray-3">
                The cost of a mortgage is not just the interest rate. Depending
                on the lender and mortgage product, there may be a number of
                additional fees to consider, including mortgage advice fees,
                product or arrangement fees, valuation fees, legal fees and
                early repayment charges.
              </div>
              <div className="content text-gray-3">
                Some fees may be included with certain mortgage products, while
                others may need to be paid separately or added to the mortgage.
                We can explain the different costs involved and help you
                understand how they could affect the overall cost of your
                mortgage, so you have a clearer picture of what you’ll be
                paying.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-3 ">
        <div className="content-container column align-center gap-l py-xxl px-xxxl">
          <LineLinkButton children="Mortgages" />
          <h4 className="uppercase text-primary-1">Mortgage Calculators</h4>
          <div className="column gap-xxl align-center">
            <div className="content text-primary-1 ">
              Our mortgage calculators can give you an initial indication of
              your potential mortgage costs.
                      </div>
            <div className="calculator-grid grid3 gap-xl width-100 flex-start">
              {calculators.map((calculator, index) => (
                <div key={index} className="calculator-card column gap-l flex-start">
                  <img
                    className="calculator-card__image width-100"
                    src={calculator.image}
                    alt={calculator.title}
                  />
                  <div className="column gap-m flex-start">
                    <h4 className="h4 italic text-primary-1 text-left">
                      {calculator.title}
                    </h4>
                    <div className="content text-primary-1 text-left">
                      {calculator.description}
                    </div>
                   <SecondaryButton text="Learn More" onClick={() => navigate(calculator.link)} />
                  </div>
                </div>
              ))}
            </div>
            <div className="body1 text-primary-1">
              *Calculator results are for illustration purposes only and are not
              a mortgage offer or guarantee of borrowing.
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-1 ">
        <div className="content-container py-xxl px-xxxl column gap-l align-center">
          <LineLinkButton onClick={scrollToContact} children="Contact Us" />
          <h4 className=" text-gray-3 uppercase">
            Ready to Discuss Your Mortgage?
          </h4>
          <div className="content text-gray-3">
            Whether you're a first-time buyer, moving home or considering a
            remortgage, Matthew can help you understand your options.
          </div>
          <SecondaryButton onClick={scrollToContact} text="MAKE AN ENQUIRY" />
        </div>
      </div>
    </div>
  );
};

export default MortgagePage;
